<div class="h-x1 flex br-4 mask bg-very-light-gray" v-if="denominator &gt; 0"><div class="bg-purple" :style="barStyle"></div></div>